import * as types from '../actionTypes';

export function setCustomerInfo(isLoading) {
  return {
    type: types.SET_CUSTOMER_INFO_PENDING,
    isLoading,
  };
}

export function setCustomerInfoSuccess(isLoading, data) {
  return {
    type: types.SET_CUSTOMER_INFO_SUCCESS,
    isLoading,
    data,
  };
}

export function setCustomerInfoError(isLoading, error) {
  return {
    type: types.SET_CUSTOMER_INFO_ERROR,
    isLoading,
    error,
  };
}

export function setErrorPage(isLoading, error) {
  return {
    type: types.SET_ERROR,
    isLoading,
    error,
  };
}

export function setAgentRemoveInfoError() {
  return {
    type: types.SET_REMOVE_ERROR,
  };
}
